export default __webpack_public_path__ + "static/media/polygon-logo.ba11b0d1.svg";